import { type RouteRecordRaw } from "vue-router";

import { APP_CALENDARS_ROUTES as CALENDAR } from "@/Generated/Routes/paths";

import { buildBeforeEnterChain, canSyncCalendars, isTherapistGuard } from "../guards";

export default [
  {
    path: CALENDAR.root.path,
    components: {
      main: () => import("@/Components/layout/BlankLayout.vue"),
      sidebar: () => import("@/Views/calendars/menu.vue"),
    },
    meta: { noHeader: true, sidebar: true, drawer: false },
    children: [
      {
        ...CALENDAR.root,
        component: () => import("@/Views/MainLanding.vue"),
      },
      {
        ...CALENDAR.view.root,
        component: () => import("@/Views/calendars/View/index.vue"),
        meta: {
          sidebar: false,
          i18nTitle: "home.navigation.schedule",
        },
      },
      {
        ...CALENDAR.sync.root,
        component: () => import("@/Views/calendars/Sync/index.vue"),
        beforeEnter: buildBeforeEnterChain([isTherapistGuard, canSyncCalendars]),
        meta: {
          sidebar: false,
          i18nTitle: "home.navigation.schedule",
        },
      },
      {
        ...CALENDAR.config.schedule.root,
        component: () => import("@/Views/calendars/Schedule/index.vue"),
        beforeEnter: buildBeforeEnterChain(isTherapistGuard),
      },
      {
        ...CALENDAR.config.advice_policy.root,
        component: () => import("@/Views/calendars/AdvicePolicy/index.vue"),
        beforeEnter: buildBeforeEnterChain(isTherapistGuard),
        meta: {
          sidebar: false,
          i18nTitle: "home.navigation.schedule",
        },
      },
    ],
  },
] as RouteRecordRaw[];
